import { CheckOutlined } from "@ant-design/icons"
import { Button, Flex, Tooltip } from "antd"
import type { ColumnType } from "antd/es/table/interface"
import React from "react"

import { type Lead } from "../../../Lead/types/lead.types.ts"

interface GetColumnsActionsArgs {
  onSelectRow: (record: Lead, action: string) => void
  saving: boolean
}

export const getActions = ({
  onSelectRow,
  saving
}: GetColumnsActionsArgs): ColumnType<Lead> => ({
  title: "Actions",
  key: "actions",
  width: 80,
  render: (_, record) => (
    <Flex justify={"center"}>
      <Tooltip title="Approve">
        <Button
          loading={saving}
          type="link"
          icon={<CheckOutlined />}
          onClick={() => onSelectRow(record, "approve")}
        />
      </Tooltip>
      {/*<Tooltip title="Reject">*/}
      {/*  <Button*/}
      {/*    loading={saving}*/}
      {/*    type="link"*/}
      {/*    icon={<CloseCircleOutlined />}*/}
      {/*    onClick={() => onSelectRow(record, "reject")}*/}
      {/*  />*/}
      {/*</Tooltip>*/}
      {/*<Tooltip title="View file">*/}
      {/*  <Button*/}
      {/*    type="link"*/}
      {/*    icon={<FileTextOutlined />}*/}
      {/*    onClick={() => onSelectRow(record, "view_file")}*/}
      {/*    disabled={!record?.file}*/}
      {/*  />*/}
      {/*</Tooltip>*/}
    </Flex>
  )
})
